export default {
  header: 'Resumo da encomenda',
  buttons: {
    checkout: 'Pagamento seguro',
    continue: 'Continuar',
    add_products: '+ Adicionar produtos',
    add_items: '+ Adicionar mais itens',
    menu: 'Menu',
  },
  empty_order_basket: {
    description: 'O seu carrinho está vazio <br/> Adicione itens para começar',
  },
  promo_code_banner: {
    single_use: '{{discount}} de desconto - {{code}}',
    multi_use: '{{discount}} de desconto em {{count}} encomendas - {{code}}',
    redeem: 'RESGATAR',
    redeemed: 'RESGATADO',
  },
  upsell: {
    title: 'As pessoas também pedem',
  },
  rewards: {
    title: 'Pagar com pontos',
    description: '<highlight>Inicie sessão</highlight> para pagar com pontos',
  },
  already_member: 'Já é membro?',
  sign_in: 'Iniciar sessão',
  summary: {
    subtotal: 'Subtotal',
    delivery: 'Entrega',
    pickup: 'Takeaway',
    total: 'Total',
    free: 'Grátis',
  },
  footer: {
    member_earning: '+{{points}} pts após o pagamento · {{balance}} pts de saldo',
    guest_earning: 'Registe-se para começar a acumular nesta encomenda',
  },
};
